import Vue from 'vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import App from './App.vue'
import router from './router'
import store from './store'
import Storage from '@/utils/storage.js' //缓存操作封装


Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.Storage = Storage

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
